import { useParams } from 'react-router';
import { DataLoader } from '@/components/ui/DataLoader';
import { CarryFundDocumentsList } from '../components/CarryFundDocumentsList';
import { useCarryFundDocuments } from '../hooks/useCarry';
import type { CarryFundDocuments } from '../services/carryService';

export function CarryFundDocumentsPage() {
  const { fundId = '' } = useParams<{ fundId: string }>();
  const documentsQuery = useCarryFundDocuments(fundId);

  return (
    <DataLoader<CarryFundDocuments> query={documentsQuery}>
      {(fund) => (
        <div className="space-y-6">
          <h1 className="text-2xl font-semibold text-foreground">
            Documents – {fund.fund_name}
          </h1>
          <CarryFundDocumentsList fund={fund} />
        </div>
      )}
    </DataLoader>
  );
}
